<template>
    <div class="right">
        <div class="scrollable-content">
            <value-editor></value-editor>
        </div>
    </div>
</template>

<script type="text/babel">
import ValueEditor from '../../ValueEditor/ValueEditor.vue';

export default {
    name: 'WorkspaceAreaRight',
    components: {
        ValueEditor
    }
};

</script>

<style lang="scss" scoped>
    .btn-nav {
        background-color: white;
        color: #00b2fa;
        border: 0;
        cursor: pointer;
    }
    
    .right {
        min-height: 100%;
        @include color('background-color', primary);
    
        .scrollable-content {
            overflow-y: auto;
            height: 100%;
            width: 100%;
            .value-editor {
                ul.list {
                    list-style-type: none;
                }
                
                
            }

            color: white;
            input, select {
                color: black !important;
            }
        }
        
    }
</style>
